<template>
    <div class="form-floating">
        <h5>
            {{ label || trans('general.page.messages.select_member') }}
        </h5>

        <basic-input
            class="mt-4 mb-2"
            v-model="searchQuery"
            placeholder="placeholder"
            :label="trans('general.defaults.search')"
            type="text"/>

        <div class="scrollable mb-3">
            <custom-radio
                v-if="options"
                v-model="model"
                :items="options"
                type="list"/>
        </div>
    </div>
</template>

<script>
import CustomRadio from "../../../theme/molecules/CustomRadio.vue";
import BasicInput from "../../../theme/atoms/BasicInput.vue";

export default {
    name: "StaffSelect",
    props: {
        placeholder: String,
        label: String
    },
    watch: {
        model: function (val) {
            this.$emit('change', val.data)
        },
        value: function (val) {
            this.model = val.data;
        },
        searchQuery (val) {
            this.load(val);
        }
    },
    components: {BasicInput, CustomRadio},
    data() {
        return {
            mode: 'activity',
            model: {value: ''},
            options: [],
            searchQuery: '',
        }
    },
    methods: {
        load(search) {
            this.search(search, this);
        },
        search: _.debounce((search, vm) => {
            axios.get(`/messages/staff`, {params: {limit: 15, include: 'roles', search, search_fields: 'name:like'}})
                .then((response) => {
                    let data = response.data.data;
                    let items = [];

                    data.forEach(function (item) {
                        items.push({
                            value: item.id,
                            cls: 'bg-primary',
                            text: `${item.name} ${item.surname}`,
                            color: 'black',
                            icon: 'fi-rr-user',
                            data: item,
                        })
                    })

                    vm.options = items;
                });
        }, 350),
    },
    mounted() {
        this.load()
    }
}
</script>

<style scoped>
.scrollable {
    max-height: 400px;
    overflow-y: auto;
}
</style>
